export function shouldRedirectToInbox(pathname) {
  const strippedSlashes = pathname.split('/').join('')
  const strippedQueryParams = strippedSlashes.split('?')[0]
  
  return strippedQueryParams === 'inboxes'
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/inbox/helpers.js